import { css } from '@emotion/react'
import { Button, Heading, HFlow, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import iconEsusIntegracao from 'images/contextual-help-card/icon-esus-integracao.svg'
import { stringGrouper } from 'util/string/string-grouper'

interface NotificacaoAgravoCardProps {
  nomesCid10: ReadonlyArray<string>
  onPreencher(): void
}

export function NotificacaoAgravoCard(props: Readonly<NotificacaoAgravoCardProps>) {
  const { nomesCid10, onPreencher } = props

  const prefixoCid10 = nomesCid10.length > 1 ? 'os CID-10' : 'o CID-10'

  return (
    <Box>
      <HFlow alignItems='center' justifyContent='space-between' hSpacing={2}>
        <HFlow alignItems='center' hSpacing={0.5}>
          <img src={iconEsusIntegracao} height={ALTURA_ICONE} alt='' css={styles.icone} />

          <VFlow vSpacing={0.25}>
            <Heading level={4}>Notificar via integração com o e-SUS SINAN</Heading>
            <Text>
              {`É compulsório criar uma notificação de agravo para ${prefixoCid10} ${stringGrouper(
                ...nomesCid10
              )}. Preencha os dados do formulário para enviar a ficha ao e-SUS SINAN.`}
            </Text>
          </VFlow>
        </HFlow>

        <Button kind='primary' skin='outline' size='small' onClick={onPreencher} style={styles.button}>
          Preencher notificação de agravo
        </Button>
      </HFlow>
    </Box>
  )
}

const ALTURA_ICONE = 64

const styles = {
  icone: css`
    flex-shrink: 0;
  `,
  button: css`
    flex-shrink: 0;
  `,
}
